import { colors, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  leftPanel: {
    flex: '0 0 85%',
    width: '85%',
    overflowY: 'auto',
    padding: theme.spacing(3),
    borderRight: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
  },
  rightPanel: {
    flex: '0 0 15%',
    width: '15%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
  },
  sectionLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: theme.spacing(0.5),
  },
  columnChip: {
    fontWeight: 600,
  },
  dpoChip: {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.common.white,
    fontWeight: 600,
  },
  autoChip: {
    backgroundColor: colors.pink[100],
    color: colors.pink[900],
  },
  headerRow: {
    gap: theme.spacing(0.75),
  },
  tabLabel: {
    minWidth: 'unset',
    fontSize: 13,
  },
  tabPanel: {
    paddingTop: theme.spacing(1.5),
  },
}))

export default useStyles
